import type { ReactNode } from "react";
import { Container, Grid } from "@mui/material";
import CommandeCardSkeleton from "components/molecules/cards/CommandeCard/CommandeCardSkeleton";
import PageTitle from "components/molecules/PageTitle";
import { rangeUtil } from "utils/rangeUtil";

function UserCommandesPageSkeleton(): ReactNode {
  return (
    <>
      <PageTitle title="Mes commandes" />
      <Container maxWidth="xl">
        <Grid container spacing={2} size={12} sx={{ alignItems: "center" }}>
          <Grid container spacing={4} size={12}>
            {rangeUtil.arrayRange(6).map((i) => (
              <Grid key={i} size={{ xs: 12, lg: 6 }}>
                <CommandeCardSkeleton />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default UserCommandesPageSkeleton;
